module.exports = "<div class=\"row no-margin-bottom\"> <div class=\"col s12 step-title-wrapper\"> <h2>{{accountType.stepTitle}}</h2> </div> </div> ";